import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HotToastService } from "@ngneat/hot-toast";
import { EMPTY, throwError } from "rxjs";
import {
	AccessNotice,
	AccessNoticeType,
	SESSION_EXPIRED_MESSAGE,
} from "../data/constants";
import { isArray, isString } from "../helpers/validate-parse-text.helper";

const MESSAGE_DEFAULT_ERROR =
	"Algo malo sucedio. Por favor, inténtelo de nuevo más tarde.";

const MESSAGE_NETWORK_ERROR =
	"No se pudo conectar con el servicio. Verifica tu conexión o vuelve a intentarlo en unos minutos.";

const arrayToStringMessage = (errors: string[]): string => {
	if (errors.length === 0) return "Error";

	if (errors.length === 1) return errors[0].toString();

	// first item
	errors[0] = `- ${errors[0]}`;

	// end item
	errors[errors.length - 1] = `${errors[errors.length - 1]}.`;

	return errors.join(".</br> - ");
};

const htmlToTextReadable = (msgErrorHtml: string, message: string): string => {
	const isTextHTML = msgErrorHtml.includes("DOCTYPE");
	return isTextHTML ? message : msgErrorHtml;
};

const getErrorText = (error: any): string => {
	let serialized = "";

	try {
		serialized = JSON.stringify(error);
	} catch {
		serialized = "";
	}

	return [
		error?.message,
		error?.errorMessage,
		error?.errorCode,
		error?.subError,
		error?.error,
		error?.error_description,
		error?.error?.detail,
		error?.error?.error,
		error?.error?.error_description,
		serialized,
	]
		.filter(Boolean)
		.join(" ")
		.toLowerCase();
};

const isSessionExpiredError = (error: any): boolean => {
	const text = getErrorText(error);

	return (
		text.includes("aadsts700084") ||
		text.includes("700084") ||
		text.includes("bad_token") ||
		text.includes("invalid_grant") ||
		text.includes("interaction_required") ||
		text.includes("login_required")
	);
};

const getMessageError = (e: HttpErrorResponse) => {
	let message = MESSAGE_DEFAULT_ERROR;

	if (isSessionExpiredError(e)) {
		return SESSION_EXPIRED_MESSAGE;
	}

	if (e.status === 0) {
		return MESSAGE_NETWORK_ERROR;
	}

	if (e.status >= 400 && e.status < 500) {
		if (isString(e.error)) return htmlToTextReadable(e.error, e.message);

		if (isArray(e.error)) return arrayToStringMessage(e.error.errors);


		if (isString(e.error?.detail)) {
			return e.error.detail;
		}

		if (isString(e.error?.errors)) {
			return e.error.errors;
		}

		if (isString(e.error?.error)) {
			return e.error.error;
		}

		if (isArray(e.error?.errors))
			return arrayToStringMessage(e.error.errors);

		if (typeof e.error.errors === "object")
			return arrayToStringMessage(Object.values(e.error.errors));
	}

	return message;
};

@Injectable({ providedIn: "root" })
export class HandleErrorService {
	constructor(private _toastService: HotToastService) { }

	getMessage(e: HttpErrorResponse) {
		return getMessageError(e);
	}

	getAccessNotice(e: HttpErrorResponse): AccessNotice {
		let type: AccessNoticeType = "unexpected";

		if (isSessionExpiredError(e)) {
			type = "session";
		} else if (e.status === 0) {
			type = "network";
		} else if (e.status === 401 || e.status === 403) {
			type = "permissions";
		} else if (e.status >= 500) {
			type = "service";
		}

		return {
			type,
			message: this.getMessage(e),
		};
	}

	handleError(e: HttpErrorResponse) {
		this._toastService.error(this.getMessage(e), { dismissible: true, duration: 3000 });
		// return EMPTY;
		return throwError(e);
	}
}
